import {
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import {
  RetrieveSearchMcCookieName,
  RetrieveSearchTripTypeCookieName
} from '../../constants/common.constants';
import { PostDataSearchState } from '../../models/postData-search-local-storage.interface';
import { UtilsService } from '../../services/utils.service';
import { preparePostDataValuesOnFindFlights } from './postData-update-values.adaptor';

export const prepareAndSetStorageData = (
  cacheKeySuffix: string,
  bookWidgetFields: BookWidgetFields,
  utilsService: UtilsService
): Promise<PostDataSearchState> => {
  return new Promise((resolve) => {
    const { redirectionPage, postDataSearch } =
      preparePostDataValuesOnFindFlights(cacheKeySuffix, bookWidgetFields);

    // Set mc_cache_key cookie for multicity trips
    if (postDataSearch.tripType === TripTypeOptions.MULTI_CITY) {
      utilsService.setCookies(RetrieveSearchMcCookieName, cacheKeySuffix);
    }
    // Set trip_type cookie for all trips
    utilsService.setCookies(
      RetrieveSearchTripTypeCookieName,
      postDataSearch.tripType
    );

    // Delete all old postdata
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('postData')) {
        localStorage.removeItem(key);
      }
    });

    // Set the local storage
    localStorage.setItem(
      `postData${cacheKeySuffix}`,
      JSON.stringify(postDataSearch)
    );

    resolve({ redirectionPage, postDataSearch });
  });
};
